import { Link, useOutletContext } from 'react-router';
import { useLanguage } from '../../../../contexts/language';
import { VesselTemplateSubPageContext } from '../types';
import { renderSkeletonCards } from '../../../../components/SkeletonElements';
import InputHeader from '../../../../components/InputHeader';
import { Button, Card, SvgIcon, TextField } from '@mui/material';
import { RiArrowRightLine } from '@remixicon/react';
import { PANEL_CARD_INNER_SPACING_CLASSNAME } from '../../../../components/AdminTemplates';

const VesselAssignmentsPage = () => {
  const { assignmentsManagement } =
    useOutletContext<VesselTemplateSubPageContext>();
  const { assignments, isLoading } = assignmentsManagement;
  const { t } = useLanguage();

  if (isLoading) {
    renderSkeletonCards(3);
  }

  return (
    <Card className={PANEL_CARD_INNER_SPACING_CLASSNAME}>
      {assignments.length === 0 ? (
        <div className="flex justify-center">
          <div className="flex flex-col gap-4 items-center w-max-[431px] text-center">
            <h2 className="text-2xl">{t('content.no-assignments-found')}</h2>
            <div>{t('content.contract-vessel-assignation-instructions')}</div>
            <Link to={'/admin/contracts'}>
              <Button
                variant="outlined"
                endIcon={<SvgIcon component={RiArrowRightLine} />}
              >
                {t('content.go-to-contracts')}
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-[1fr_145px_min-content] gap-x-4">
          <header className="col-span-full grid grid-cols-subgrid">
            <InputHeader>{t('content.contract-name')}</InputHeader>
            <InputHeader>{t('content.assignment')}</InputHeader>
          </header>
          <ul className="col-span-full grid grid-cols-subgrid">
            {assignments.map(assignment => (
              <li
                key={assignment.contractId}
                className="col-span-full grid grid-cols-subgrid mb-4"
              >
                <TextField
                  aria-readonly
                  value={[
                    assignment.contract.label,
                    assignment.contract.issue &&
                      `(${t(`content.${assignment.contract.issue}`)})`,
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  disabled
                />
                <TextField
                  aria-readonly
                  value={t(
                    `content.${assignment.isPrimary ? 'primary' : 'backup'}`,
                  )}
                  disabled
                />
                <Link to={`/admin/contracts/${assignment.contractId}/vessels`}>
                  <Button
                    variant="contained"
                    className="whitespace-nowrap"
                    endIcon={<SvgIcon component={RiArrowRightLine} />}
                  >
                    {t(`content.see-contract`)}
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Card>
  );
};

export default VesselAssignmentsPage;
